import { Box, Flex, IconButton, Text, Tooltip, VStack, XOutline } from '@bonusly/design-system';

import { ConnectorsSection } from '../../components/bizy-settings/connectors-section';
import { EverboardingSection } from '../../components/bizy-settings/everboarding-section';
import { MemoriesSection } from '../../components/bizy-settings/memories-section';
import { MotionSection } from '../../components/bizy-settings/motion-section';
import { ProfileSection } from '../../components/bizy-settings/profile-section';
import { useBizySidePanelStore } from '../../components/bizy-side-panel/store/use-bizy-side-panel-store';

interface BizySettingsProps {
	onBack: () => void;
}

export const BizySettings = ({ onBack }: BizySettingsProps) => {
	const isFullscreen = useBizySidePanelStore((state) => state.isFullscreen);

	return (
		<Flex direction="column" h="100%">
			<Flex align="center" justify="space-between" pl={4} pr={3} py={3} flexShrink={0}>
				<Text fontWeight="semibold" fontSize="sm" color="text.default">
					Bizy Settings
				</Text>
				<Tooltip label="Close settings" hasArrow={false}>
					<IconButton
						aria-label="Close settings"
						icon={<XOutline boxSize={5} />}
						variant="ghost"
						size="sm"
						color="secondary.fg"
						_hover={{ bg: 'secondary.bgAlpha' }}
						onClick={onBack}
					/>
				</Tooltip>
			</Flex>

			<Box flex={1} overflowY="auto" overscrollBehavior="contain" px={4} pb={4}>
				<VStack spacing={6} align="stretch" maxW={isFullscreen ? '720px' : undefined} mx={isFullscreen ? 'auto' : undefined}>
					<ProfileSection />
					<MemoriesSection />
					<EverboardingSection />
					<ConnectorsSection />
					<MotionSection />
				</VStack>
			</Box>
		</Flex>
	);
};
